<template>
  <section class="block-stats">
    <div v-if="block.heading || block.body">
      <h2 v-if="block.heading">{{ block.heading }}</h2>
      <div v-if="block.body" v-html="block.body" />
    </div>
    <div class="block-stats__group">
      <div
        class="block-stats__group__item"
        v-for="(item, index) in block.statisticGroup"
        :key="`block-stats-${index}`"
      >
        <span>{{ item.number }}</span>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BlockStatistics',
  props: {
    block: [Array, Object]
  }
};
</script>

<style lang="postcss">
.block-stats {
  @apply text-brand-darkerBlue;
  @apply flex flex-col;
  align-items: center;
  @apply py-16;
  gap: 3rem;
  @apply bg-brand-white;
  @screen sm {
    @apply py-48;
  }
  h2 {
    @apply font-ginto-black text-center;
    font-size: calc(20px + (40 - 20) * (100vw - 640px) / (1920 - 640));
    line-height: 1.375;
    margin-bottom: 1rem;
  }
  p {
    max-width: 70ch;
    font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
    @apply font-ginto-regular;
    a {
      @apply border-b border-brand-blue;
      @apply pb-1;
    }
    &:only-of-type {
      @apply text-center;
    }
  }
  em {
    @apply font-ginto-regular-italic;
  }
  p:not(:last-child) {
    @apply mb-8;
  }
  &__group {
    width: 100%;
    @apply z-30;
    @apply flex flex-col justify-evenly items-center;
    @apply text-brand-darkerBlue;
    @screen sm {
      @apply flex-row items-start;
    }
    &__item {
      @apply pb-8;
      @apply text-center;
      @apply max-w-sm;
      @screen sm {
        @apply pb-16;
        @apply max-w-3xl;
        @apply px-16;
      }
      span {
        @apply font-ginto-black;
        @apply mb-4;
        @apply inline-block;
        font-size: calc(28px + (80 - 28) * (100vw - 640px) / (1920 - 640));
      }
      p {
        @apply font-ginto-regular;
        font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
      }
    }
  }
}
</style>
